/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslate } from './../../translate/I18n';
import { useTerritory } from '../../hooks/useTerritory';

import SkillsInput from './../elements/formHook/Skills';
import { searchSkill } from '../../store/skills/skills.search';
import ButtonGradient from '../atoms/ButtonGradient';
import { useRouter } from '../../utils/router';

import companyRoutes from '../../routes/company';
import Box from '../atoms/Box';
import Text from '../atoms/Text';
const { registerWithMission } = companyRoutes;

const defaultHardSkills = [
  {
    id: '',
    text: '',
    level: 3
  }
];

const FindFreelancersWithSkills = () => {
  const { t } = useTranslate();
  const history = useRouter();
  const territory = useTerritory();
  const formHook = useForm({ defaultValues: { hardSkills: defaultHardSkills } });
  const { register, handleSubmit, watch, errors } = formHook;
  const currentHardSkills = watch('hardSkills') ?? [];

  const onSubmit = skills => {
    history.push({
      pathname: registerWithMission.to,
      query: { data: JSON.stringify(skills) }
    });
  };

  const hasEnoughSkills = currentHardSkills.length > 3;

  return (
    <>
      <FormProvider {...formHook}>
        <form onSubmit={handleSubmit(onSubmit)} noValidate>
          <SkillsInput
            name={'hardSkills'}
            ref={register}
            searchSkill={searchSkill('hard')}
            inline={true}
            canBeMandatory={false}
          />
          <Box textAlign="center" mt="4">
            <Text
              color="#111517"
              mx="auto"
              mt={1}
              mb={2}
              bg="#F1F1F1"
              borderRadius="2"
              border="1px solid #E1E1E1"
              py="4px"
              px="2"
              display={hasEnoughSkills ? 'inline-block' : 'none'}>
              {t('registerWithMission:skills.hasEnoughSkills', { value: 3 })}
            </Text>
            <Box>
              <ButtonGradient type="submit" styleType="secondary">
                {t('homePageCompany:findFreelancer')}
              </ButtonGradient>
            </Box>
          </Box>
        </form>
      </FormProvider>
    </>
  );
};

export default FindFreelancersWithSkills;
